import React, { useState } from "react";
import { TableContainer, TableHeading } from "./Table.style";
import { Image } from "../../shared/Styles/sharedStyles";
import Player from "../Player";
import axios from "axios";
import { useQuery } from "react-query";
import Constants from "../../constants";
import { GameFormats } from "../../pages/CompetitionLeaderboardPage";

function Table({ isLoading, Participants, isGross, competitionMaster }: any) {
  const [currentPaginationNumber, setCurrentPaginationNumber] = useState(0);
  const total = 24;
  const pageSize = 24 / 3;

  if (!Participants) {
    return <>Nothing to display</>;
  }

  if (isLoading) {
    return (
      <h2
        style={{
          color: "white",
        }}
      >
        Loading...
      </h2>
    );
  }

  function capitalizeFirstLetter(string: any) {
    // if (string.toLowerCase().includes("undefined")) {
    //   string.toLowerCase().replaceAll("undefined", "");
    // }

    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  function generateNickName(username: any) {
    let originalUsername = username;
    originalUsername = originalUsername.trim();
    // console.log("MY USERNAME", originalUsername);
    originalUsername = originalUsername.replace(/\s\s+/g, " ");
    const wordsInUsername = originalUsername.split(" ");
    // console.log("MY USERNAME", wordsInUsername);

    let nickName = "";

    if (wordsInUsername.length > 0) {
      if (wordsInUsername.length == 2) {
        nickName =
          capitalizeFirstLetter(wordsInUsername[0]) +
          " " +
          capitalizeFirstLetter(wordsInUsername[1][0]) +
          ".";
        // console.log("LENGTH 2", nickName);
      } else if (wordsInUsername.length == 3) {
        nickName =
          capitalizeFirstLetter(wordsInUsername[0]) +
          " " +
          capitalizeFirstLetter(wordsInUsername[2][0]) +
          ".";
      } else {
        nickName =
          capitalizeFirstLetter(wordsInUsername[0]) +
          " " +
          capitalizeFirstLetter(
            wordsInUsername[wordsInUsername.length - 1][0]
          ) +
          ".";
      }
    }

    // console.log("WORDS ARR", wordsInUsername);
    // console.log("Nickname", nickName);
    // console.log(
    //   "Condition",
    //   player.points.TotalPoint && player.points.TotalPoint >= 0
    // );

    if (nickName.includes("undefined")) {
      // alert("HELLO");
      nickName = nickName.replace("undefined", "");
      // console.log("NICKNAME AFTER", nickName);
    }

    const finalWordsInNickName = nickName.split(" ");
    if (finalWordsInNickName.length == 2 && finalWordsInNickName[1] == ".") {
      nickName = nickName.replace(".", "");
    }

    // console.log("final words", nickName);

    return nickName;
  }

  const renderScore = (player: any) => {
    // console.log(
    //   "player points",
    //   competitionMaster?.scoringMethod,
    //   isGross,
    //   player.userName,
    //   player.points
    // );
    if (isGross && player.points.TotalPoint !== "0") {
      return player?.points?.GrossScoreTotal;
    }

    if (competitionMaster?.scoringMethod === GameFormats.Stableford) {
      return player?.points?.TotalPoint;
    }

    if (
      competitionMaster?.scoringMethod === GameFormats.Strokeplay &&
      !isGross
    ) {
      return getToParValue(
        player?.points?.NetScoreTotal,
        player?.points?.ParPlayed
      );
    }

    if (
      competitionMaster?.scoringMethod === GameFormats.DoublePeoria &&
      !isGross
    ) {
      return player.points.PeoriaNetScore;
    }

    return "-";
  };

  const renderHCP = (player: any) => {
    if (
      competitionMaster?.scoringMethod === GameFormats.DoublePeoria &&
      !isGross
    ) {
      return player?.peoriaHandicap;
    }

    return player?.handicap;
  };

  const renderScoreHeading = () => {
    if (isGross) {
      return "GROSS";
    }

    if (competitionMaster?.scoringMethod === GameFormats.Stableford) {
      return "POINTS";
    }

    if (
      competitionMaster?.scoringMethod === GameFormats.Strokeplay &&
      !isGross
    ) {
      return "NET SCR";
    }

    if (
      competitionMaster?.scoringMethod === GameFormats.DoublePeoria &&
      !isGross
    ) {
      return "PEORIA SCR";
    }

    return "SCR";
  };

  return (
    <div>
      <TableContainer>
        <thead>
          <TableHeading>
            <th>#</th>
            <th>PLAYER</th>
            <th>{renderScoreHeading()}</th>
            <th>{isGross ? "HCP" : "HCP"}</th>
          </TableHeading>
        </thead>
        <tbody>
          {Participants?.map((player: any) => (
            <tr key={player.userId}>
              <td
                style={{
                  padding: "5px",
                  textAlign: "center",
                  fontSize: "30px",
                }}
              >
                {player.position ? player.position : "-"}
              </td>
              <td>
                <Player
                  playerName={
                    generateNickName(player.userName).length >
                    Constants.playerNameInLeaderboardCharacterLimit
                      ? generateNickName(player.userName).slice(
                          0,
                          Constants.playerNameInLeaderboardCharacterLimit
                        ) + "..."
                      : generateNickName(player.userName)
                  }
                  playerFullName={player.userName}
                  profileImgUrl={player.imageUrl}
                  showFullName={true}
                />
              </td>
              <td
                style={{
                  textAlign: "center",
                  padding: "18px 10px",
                }}
              >
                {renderScore(player)}
              </td>
              <td
                style={{
                  textAlign: "center",
                  padding: "18px 10px",
                }}
              >
                {renderHCP(player)}
              </td>
            </tr>
          ))}
        </tbody>
      </TableContainer>
    </div>
  );
}

function getToParValue(gross: number | null, par: number | null): string {
  const toPar = (gross ?? 0) - (par ?? 0);
  if (toPar === 0) {
    return "0";
  }
  return `${toPar < 0 ? "" : "+"}${toPar}`;
}

export default Table;
